import { reactive, markRaw } from 'vue';

const workspaces = reactive(new Map());

export function getPhotoWorkspace(viewId) {
    if (!workspaces.has(viewId))
        workspaces.set(viewId, {
            model: null,
            photos: [],
            active: false,
            galleryOpen: false,
            layout: 'overlay',
            selected: null,
            autoSync: true,
            syncRevision: 0,
            photoRect: null,
            error: '',
            loading: false
        });
    return workspaces.get(viewId);
}

export function setPhotoWorkspaceModel(viewId, model, photos = []) {
    const workspace = getPhotoWorkspace(viewId);
    if (workspace.model === model) return;
    Object.assign(workspace, {
        model: model ? markRaw(model) : null,
        photos,
        active: false,
        galleryOpen: false,
        layout: 'overlay',
        selected: null,
        photoRect: null,
        error: '',
        loading: false
    });
}

export function findPhotoWorkspace(inspectionViewUuid) {
    if (!inspectionViewUuid) return null;
    return (
        Array.from(workspaces.values()).find(
            (workspace) =>
                workspace.active &&
                workspace.model?.inspectionViewUuid === inspectionViewUuid
        ) || null
    );
}

export function refreshPhotoWorkspacePhotos(model, photos) {
    if (!model) return;
    for (const workspace of workspaces.values()) {
        if (workspace.model !== model) continue;
        const existing = new Map(workspace.photos.map(photo => [photo.image_uuid, photo]));
        workspace.photos = photos.map(photo => {
            const previous = existing.get(photo.image_uuid);
            return previous?.image === photo.image ? previous : photo;
        });
    }
}

export function selectWorkspacePhoto(workspace, photo) {
    if (!workspace?.photos.includes(photo)) return false;
    const samePhoto = workspace.selected?.image_uuid === photo.image_uuid;
    workspace.selected = photo;
    if (!samePhoto) workspace.photoRect = null;
    workspace.error = '';
    workspace.syncRevision += 1;
    return true;
}

export function clearPhotoWorkspace(viewId) {
    workspaces.delete(viewId);
}

export function deactivatePhotoWorkspaces(views = []) {
    for (const view of views) {
        const workspace = workspaces.get(view.id);
        if (!workspace) continue;
        workspace.active = false;
        workspace.galleryOpen = false;
        workspace.layout = 'overlay';
        workspace.error = '';
    }
}

// Use the same crop in both panes, even when their aspect ratios differ.
export function workspacePhotoRect(fractions, viewport) {
    if (!fractions || !viewport?.width || !viewport?.height) return null;
    if (
        ![
            fractions.left,
            fractions.top,
            fractions.width,
            fractions.height
        ].every(Number.isFinite) ||
        fractions.width <= 0 ||
        fractions.height <= 0
    )
        return null;
    return {
        left: fractions.left * viewport.width,
        top: fractions.top * viewport.height,
        width: fractions.width * viewport.width,
        height: fractions.height * viewport.height
    };
}
